import React, { useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import './BannerUpload.scss'
import { useDeleteImageMutation } from '../../../../../store/api/generalInfoApi'
import { serverUrl } from '../../../../../request'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from '@fortawesome/free-solid-svg-icons'

interface FileWithPreview extends File {
  preview: string
}

type Props = {
  files: FileWithPreview[]
  setFiles: React.Dispatch<React.SetStateAction<FileWithPreview[]>>
  setImages: React.Dispatch<React.SetStateAction<string[]>>
  images: Array<string>
}

const c = 'banner-upload'

const BannerUpload = ({ files, setFiles, images, setImages }: Props) => {
  const [deleteImage] = useDeleteImageMutation()
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': [],
    },
    maxFiles: 100,
    onDrop: (acceptedFiles: File[]) => {
      const newFiles = acceptedFiles.map((file: File) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      ) as FileWithPreview[]
      setFiles((prev) => [...prev, ...newFiles])
      setImages((prev) => [
        ...prev,
        ...newFiles.map((f: FileWithPreview) => f.preview),
      ])
    },
  })

  function handleDeleteImage(url: string) {
    deleteImage(url.replace(serverUrl, ''))
    setImages((prev: string[]) => {
      return prev.filter((image: string) => image !== url)
    })
  }

  useEffect(() => {
    return () =>
      files.forEach((file: FileWithPreview) =>
        URL.revokeObjectURL(file.preview),
      )
  }, [])

  return (
    <section className={c}>
      <div {...getRootProps()} className={`${c}__dropzone`}>
        <input {...getInputProps()} />
        <p>Incarca una sau mai multe imagini</p>
      </div>
      <aside className={`${c}__previews`}>
        {images.map((image: string) => (
          <div key={image} className={`${c}__previews-item`}>
            <div className={`${c}__previews-item-image`}>
              <img
                src={image}
                onLoad={() => {
                  URL.revokeObjectURL(image)
                }}
              />
              <div
                className={`${c}__previews-item-image-close`}
                onClick={() => handleDeleteImage(image)}
              >
                <FontAwesomeIcon icon={faClose} />
              </div>
            </div>
          </div>
        ))}
      </aside>
    </section>
  )
}

export default BannerUpload
